import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";
import { PublicInterceptorPR } from "../../../Base/interceptors/PublicInterceptorsPR";



export const getEncuestas = async () => {
    return await PrivateInterceptorsPR('Payrolls/Encuestas/', 'GET');
}

export const getPreguntasEncuesta = async (idEncuesta) => {
    return await PrivateInterceptorsPR(`Payrolls/Encuestas/Preguntas/${idEncuesta}`, 'GET');
}
export const getPreguntasEncuestaArea = async (idEncuesta) => {
    return await PrivateInterceptorsPR(`Payrolls/Encuestas/Preguntas/Area/${idEncuesta}`, 'GET');
}

export const setQRStatus = async (data) => {
    return await PrivateInterceptorsPR(`Payrolls/Encuestas/changeQRStatus`, 'POST', data);
}

export const getParticipaciones = async (IdEncuesta) => {
    const resp = await PrivateInterceptorsPR(`Payrolls/Encuestas/getParticipaciones/${IdEncuesta}`, 'GET');
    return resp;
}

export const getComentarios = async () => {
    const resp = await PrivateInterceptorsPR(`Payrolls/Encuestas/getComentarios`, 'GET');
    return resp;
}